module.exports = __webpack_public_path__ + "img/dividend.5fed0e34.svg";